import CloseIcon from "@/common/images/icons/x.svg?react";
import ChevronIcon from "@/common/images/icons/chevron.svg?react";
import { Button } from "@/components/buttons/Button";
import { useFullscreenToggle } from "./hooks/useFullscreenToggle";
import { useFeedPagination } from "./hooks/useFeedPagination";
import "./FullScreenNav.scss";

interface FullScreenNavProps {
  previewFeedRef: React.RefObject<HTMLDivElement | null>;
}

export const FullScreenNav = ({ previewFeedRef }: FullScreenNavProps) => {
  const toggleFullScreen = useFullscreenToggle();
  const { previous, next } = useFeedPagination(previewFeedRef);

  return (
    <div className="fullScreenNavContainer">
      <div className="fullScreenNav">
        <Button
          round
          variant="tertiary"
          className="navButton closeButton"
          size="s"
          onClick={toggleFullScreen}
          aria-label="Close video"
        >
          <CloseIcon />
        </Button>

        <div className="navButtons">
          <Button
            variant="tertiary"
            round
            className="navButton prevButton"
            size="s"
            onClick={previous}
            aria-label="Previous video"
          >
            <ChevronIcon />
          </Button>

          <Button
            variant="tertiary"
            round
            className="navButton nextButton"
            size="s"
            onClick={next}
            aria-label="Next video"
          >
            <ChevronIcon />
          </Button>
        </div>
      </div>
    </div>
  );
};

